export const TENDER_ACTION_QUERY_PARAM = 'action';

export enum TenderAction {
  DECLINE = 'decline',
}
